import React, { useState, useEffect } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AlertComponent from '../../../../../../../../components/Alert';
import { delay, getErrorMessage } from '../../../../../../../../utils/helper';
import { themesRename } from '../../../../../../../../services/endpoints/themes';
import Loader from '../../../../../../../../components/Loaders/Loader';

const RenameModal = ({ data, onHide, onSubmit }) => {
  const [form, setForm] = useState({
    modalData: data,
    name: '',
    isLoading: false,
    error: null,
    success: false,
  });

  const { modalData, isLoading, error, success } = form;

  const onSaveChanges = async (e) => {
    e.preventDefault();

    setForm((prevState) => ({
      ...prevState,
      isLoading: true,
    }))

    try {
      await themesRename(modalData.id, {
        name: form.name,
      })
      setForm((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500);
      onSubmit();
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setForm((prevState) => ({
        ...prevState,
        isLoading: false,
        error: errorMessage,
      }))
    }
  }

  const onChangeName = (e) => {
    const value = e.target.value;
    setForm((prevState) => ({
      ...prevState,
      name: value,
    }))
  }

  useEffect(() => {
    setForm((prevState) => ({
      ...prevState,
      name: data?.name || '',
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form onSubmit={onSaveChanges}>
      <Modal.Header closeButton>
        <Modal.Title>Rename theme</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? <Loader success={success} /> : null }
        {error && <AlertComponent text={error} type="danger" />}
        <FormGroup>
          <ControlLabel htmlFor="theme-name">
            Name
          </ControlLabel>
          <FormControl
            id="theme-name"
            type="text"
            value={form.name}
            onChange={onChangeName}
          />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button
          disabled={isLoading}
          bsStyle="primary"
          type="submit"
        >
          <span>Save changes</span>
        </Button>
        <Button
          disabled={isLoading}
          onClick={onHide}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </form>
  );
};

RenameModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default RenameModal;
